import { createContext, useContext, useEffect } from 'react';

// Which look a league uses: varsity for college, arena (dark) for pro.
// Everything outside a league uses hardwood. See themes.scss.
export function leagueTheme(league) {
    if (!league) return 'hardwood';
    return league.type === 'pro' ? 'arena' : 'varsity';
}

// Lets a page inside AppShell switch the whole frame's theme while it's
// shown (e.g. an admin league page), and switch it back when it leaves.
export const ShellThemeContext = createContext(() => {});

export function useShellTheme(theme) {
    const setTheme = useContext(ShellThemeContext);
    useEffect(() => {
        setTheme(theme);
        return () => setTheme(null);
    }, [theme, setTheme])
}
